import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IConfigurationResolverService = ( createDecorator('configurationResolverService'));
export { IConfigurationResolverService };
